import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface HelpSearchProps {
	value: string;
	onChange: (value: string) => void;
}

export const HelpSearch = ({ value, onChange }: HelpSearchProps) => {
	const { t } = useTranslation();

	return (
		<div className="relative">
			<Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
			<Input
				type="search"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={t("help.search.placeholder")}
				className="pl-10 pr-10 h-11"
			/>
			{value && (
				<Button
					type="button"
					variant="ghost"
					size="sm"
					onClick={() => onChange("")}
					className="absolute right-1 top-1/2 -translate-y-1/2 h-8 w-8 p-0"
					aria-label="Clear search"
				>
					<X className="h-4 w-4" />
				</Button>
			)}
		</div>
	);
};
